// extracted by mini-css-extract-plugin
export default {"currentMainCell":"PerformanceMetrics__currentMainCell__fXDvg"};